const $5bd664b2c2097101$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

const $5239c8faf3deeab7$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;


const $8c2dbee053ff7e50$export$8793edee2d425525 = ()=>{};
const $8c2dbee053ff7e50$export$ea6e51872ab1b721 = (v)=>v;



const $df02ab6d5bda398c$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);


function $76780cc8b70f8057$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5239c8faf3deeab7$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}
function $76780cc8b70f8057$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $76780cc8b70f8057$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}



const $ef9ff69de29665e7$export$7e4aa119212bc614 = (value)=>typeof value === "number";


const $febb50227c34a2a5$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $ef9ff69de29665e7$export$7e4aa119212bc614)(easing[0]);


const $f8c3cc00133008b9$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


function $cddb4fbf41ced5d1$export$41c5e731255a462(easing, i) {
    return (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing[(0, $f8c3cc00133008b9$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


const $000ffd8ed17bc014$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


function $487956b5a5e61377$export$89e29e4ab65e70a9(output, input = (0, $76780cc8b70f8057$export$24dbcec0b26e6d9d)(output.length), easing = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $76780cc8b70f8057$export$dafee61230cf05c6)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $000ffd8ed17bc014$export$7d15b64cf5a3a4c4)(0, 1, (0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(input[i], input[i + 1], t));
        const segmentEasing = (0, $cddb4fbf41ced5d1$export$41c5e731255a462)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $5239c8faf3deeab7$export$2c9e8a9632a706b2)(output[i], output[i + 1], progressInRange);
    };
}

const $0e1b5b1c07f8fb28$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);



/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $ef2070365d260bba$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $ef2070365d260bba$var$subdivisionPrecision = 0.0000001;
const $ef2070365d260bba$var$subdivisionMaxIterations = 12;
function $ef2070365d260bba$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $ef2070365d260bba$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $ef2070365d260bba$var$subdivisionPrecision && ++i < $ef2070365d260bba$var$subdivisionMaxIterations);
    return currentT;
}
function $ef2070365d260bba$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $8c2dbee053ff7e50$export$ea6e51872ab1b721;
    const getTForX = (aX)=>$ef2070365d260bba$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $ef2070365d260bba$var$calcBezier(getTForX(t), mY1, mY2);
}


const $e6ebd873cf586cf2$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $000ffd8ed17bc014$export$7d15b64cf5a3a4c4)(0, 1, rounded / steps);
    };



const $b1486eeffa0df25c$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(easing[0]);

const $cbc813b470d2e71a$export$f6e2535fb5126e54 = (value)=>typeof value === "function";


const $a5838e105309f1af$var$namedEasings = {
    ease: (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.0, 0.0, 0.58, 1.0)
};
const $a5838e105309f1af$var$functionArgsRegex = /\((.*?)\)/;
function $a5838e105309f1af$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $b1486eeffa0df25c$export$77290801a62f77a2)(definition)) return (0, $ef2070365d260bba$export$2c575fa1d20488bd)(...definition);
    // If we have a predefined easing function, return
    if ($a5838e105309f1af$var$namedEasings[definition]) return $a5838e105309f1af$var$namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $a5838e105309f1af$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $e6ebd873cf586cf2$export$be3f796aed065412)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $8c2dbee053ff7e50$export$ea6e51872ab1b721;
}


class $6833b212a66a13ab$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration, delay: delay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).repeat, offset: offset, direction: direction = "normal", autoplay: autoplay = true } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing;
        if ((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721) : (0, $a5838e105309f1af$export$9681b459c1c8f0f4)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $487956b5a5e61377$export$89e29e4ab65e70a9)(keyframes, offset, (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing.map((0, $a5838e105309f1af$export$9681b459c1c8f0f4)) : (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        if (autoplay) this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}


var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};


/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $f1fe0ff64005dcb1$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}


const $311e1e8e1f9e358b$var$data = new WeakMap();
function $311e1e8e1f9e358b$export$213eea93596b44f(element) {
    if (!$311e1e8e1f9e358b$var$data.has(element)) $311e1e8e1f9e358b$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $311e1e8e1f9e358b$var$data.get(element);
}
function $311e1e8e1f9e358b$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $f1fe0ff64005dcb1$export$8cea36d14ee64562)());
    return motionValues.get(name);
}


function $fc2fda2411a55cab$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $fc2fda2411a55cab$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $348b94d3fcbeadef$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $348b94d3fcbeadef$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $348b94d3fcbeadef$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $348b94d3fcbeadef$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $348b94d3fcbeadef$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $348b94d3fcbeadef$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721)
    },
    skew: $348b94d3fcbeadef$var$rotation
};
const $348b94d3fcbeadef$export$a9dad2abc3d443d = new Map();
const $348b94d3fcbeadef$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $348b94d3fcbeadef$var$transforms = [
    "x",
    "y",
    "z"
];
$348b94d3fcbeadef$var$order.forEach((name)=>{
    $348b94d3fcbeadef$export$a9a762b9618d4a18.forEach((axis)=>{
        $348b94d3fcbeadef$var$transforms.push(name + axis);
        $348b94d3fcbeadef$export$a9dad2abc3d443d.set($348b94d3fcbeadef$export$7bbd29b1fa8b68d4(name + axis), $348b94d3fcbeadef$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $348b94d3fcbeadef$export$11410fe03e8c4042 = (a, b)=>$348b94d3fcbeadef$var$transforms.indexOf(a) - $348b94d3fcbeadef$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $348b94d3fcbeadef$var$transformLookup = new Set($348b94d3fcbeadef$var$transforms);
const $348b94d3fcbeadef$export$8a546e9da811625d = (name)=>$348b94d3fcbeadef$var$transformLookup.has(name);
const $348b94d3fcbeadef$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($348b94d3fcbeadef$export$97b5d3c90609c212[name]) name = $348b94d3fcbeadef$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $311e1e8e1f9e358b$export$213eea93596b44f)(element);
    (0, $fc2fda2411a55cab$export$20e507e47fae79fd)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $348b94d3fcbeadef$export$785216816cb6f870(transforms);
};
const $348b94d3fcbeadef$export$785216816cb6f870 = (transforms)=>transforms.sort($348b94d3fcbeadef$export$11410fe03e8c4042).reduce($348b94d3fcbeadef$var$transformListToString, "").trim();
const $348b94d3fcbeadef$var$transformListToString = (template, name)=>`${template} ${name}(var(${$348b94d3fcbeadef$export$7bbd29b1fa8b68d4(name)}))`;


const $97eae2e568a82834$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $97eae2e568a82834$export$7a740cb9e3dd106d = new Set();
function $97eae2e568a82834$export$9fdd8c2f6f59adb0(name) {
    if ($97eae2e568a82834$export$7a740cb9e3dd106d.has(name)) return;
    $97eae2e568a82834$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).has(name) ? (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}


const $4b4a0c48a96411e5$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};




const $1d8d0809bbc8866f$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $1d8d0809bbc8866f$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $1d8d0809bbc8866f$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($1d8d0809bbc8866f$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $1d8d0809bbc8866f$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $1d8d0809bbc8866f$var$results = {};
const $1d8d0809bbc8866f$export$cde6a56f9669daf6 = {};
for(const key in $1d8d0809bbc8866f$var$featureTests)$1d8d0809bbc8866f$export$cde6a56f9669daf6[key] = ()=>{
    if ($1d8d0809bbc8866f$var$results[key] === undefined) $1d8d0809bbc8866f$var$results[key] = $1d8d0809bbc8866f$var$featureTests[key]();
    return $1d8d0809bbc8866f$var$results[key];
};


// Create a linear easing point for every x second
const $faeb0e3815256700$var$resolution = 0.015;
const $faeb0e3815256700$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $faeb0e3815256700$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $faeb0e3815256700$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(easing)) return (0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).linearEasing() ? `linear(${$faeb0e3815256700$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing;
    else return (0, $b1486eeffa0df25c$export$77290801a62f77a2)(easing) ? $faeb0e3815256700$export$2523b8f0bd8f44cb(easing) : easing;
};
const $faeb0e3815256700$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



function $ce61df036a16535b$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $ce61df036a16535b$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];




function $c198c52b86dad803$export$b6557f397a74f857(key) {
    if ((0, $348b94d3fcbeadef$export$97b5d3c90609c212)[key]) key = (0, $348b94d3fcbeadef$export$97b5d3c90609c212)[key];
    return (0, $348b94d3fcbeadef$export$8a546e9da811625d)(key) ? (0, $348b94d3fcbeadef$export$7bbd29b1fa8b68d4)(key) : key;
}



const $fd426721c0ea44ce$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $c198c52b86dad803$export$b6557f397a74f857)(name);
        let value = (0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $c198c52b86dad803$export$b6557f397a74f857)(name);
        if ((0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};



function $d02340a0b8eda13b$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}


const $2a81f6ce54bbc186$export$844ec244b1367d54 = (value)=>typeof value === "string";


function $ad3259e3871471aa$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $2a81f6ce54bbc186$export$844ec244b1367d54)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}


function $a3dd283a70afc00d$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $a3dd283a70afc00d$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $a3dd283a70afc00d$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration, delay: delay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).repeat, easing: easing = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false, autoplay: autoplay = true } = options;
    const data = (0, $311e1e8e1f9e358b$export$213eea93596b44f)(element);
    const valueIsTransform = (0, $348b94d3fcbeadef$export$8a546e9da811625d)(key);
    let canAnimateNatively = (0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $348b94d3fcbeadef$export$40eba1f1af915c93)(element, key);
    const name = (0, $c198c52b86dad803$export$b6557f397a74f857)(key);
    const motionValue = (0, $311e1e8e1f9e358b$export$c0999ba824977ca6)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $d02340a0b8eda13b$export$3cc6f911ef1fd837)(motionValue.animation, !((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $fd426721c0ea44ce$export$1d567c320f4763bc).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $ce61df036a16535b$export$3d2f5b3e7004e0cf)((0, $ce61df036a16535b$export$388e66a97327a012)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $ad3259e3871471aa$export$4bcf070800a2fd35)(keyframes, definition);
        if ((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name)) {
            if ((0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).cssRegisterProperty()) (0, $97eae2e568a82834$export$9fdd8c2f6f59adb0)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).linearEasing() && ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(easing) || (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) && easing.some((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $ef9ff69de29665e7$export$7e4aa119212bc614)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(delay),
                duration: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(duration),
                endDelay: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(endDelay),
                easing: !(0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? (0, $faeb0e3815256700$export$284d1118c33f9836)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing.map((thisEasing)=>(0, $faeb0e3815256700$export$284d1118c33f9836)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $8c2dbee053ff7e50$export$8793edee2d425525));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, definition && (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        if (animation && !autoplay) animation.pause();
        return animation;
    };
}


const $14bcec4e4efa8097$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);


function $f571a32549c818c8$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}




const $5bb653941caaff3c$var$createAnimation = (factory)=>factory();
const $5bb653941caaff3c$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration)=>{
    return new Proxy({
        animations: animationFactory.map($5bb653941caaff3c$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $5bb653941caaff3c$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $5bb653941caaff3c$var$getActiveAnimation = (state)=>state.animations[0];
const $5bb653941caaff3c$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $5bb653941caaff3c$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($5bb653941caaff3c$var$selectFinished)).catch((0, $8c2dbee053ff7e50$export$8793edee2d425525));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $d02340a0b8eda13b$export$3cc6f911ef1fd837)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $5bb653941caaff3c$var$selectFinished = (animation)=>animation.finished;




function $9c5540e6e2a50ade$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(from) ? from : $9c5540e6e2a50ade$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $a5838e105309f1af$export$9681b459c1c8f0f4)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $9c5540e6e2a50ade$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $9c5540e6e2a50ade$export$4cf8f03b86be8175(option, i, total) {
    return (0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(option) ? option(i, total) : option;
}


function $a4ef3c5815e968bc$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $f571a32549c818c8$export$90ceba2564a894f8)(elements);
        const numElements = elements.length;
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $14bcec4e4efa8097$export$d2312e68e1f5ad00)(options, key);
                valueOptions.delay = (0, $9c5540e6e2a50ade$export$4cf8f03b86be8175)(valueOptions.delay, i, numElements);
                const animation = (0, $a3dd283a70afc00d$export$c76cd972d26986f9)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $5bb653941caaff3c$export$c5e4bb50450218c1)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}


const $58860c6fe607092e$export$e3607ec2d7a891c4 = (0, $a4ef3c5815e968bc$export$2a47ca22dbf0bb08)((0, $6833b212a66a13ab$export$c35d437ae5945fcd));




function $412ac00cff8309b0$export$290670472807ab5b(target, options = {}) {
    return (0, $5bb653941caaff3c$export$c5e4bb50450218c1)([
        ()=>{
            const animation = new (0, $6833b212a66a13ab$export$c35d437ae5945fcd)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $412ac00cff8309b0$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(target) ? $412ac00cff8309b0$export$290670472807ab5b : (0, $58860c6fe607092e$export$e3607ec2d7a891c4);
    return factory(target, keyframesOrOptions, options);
}


const $cdb2fa5b2f07190d$export$ebe90cb607ad99e = {
    stiffness: 100.0,
    damping: 10.0,
    mass: 1.0
};



const $535154748141eab4$export$7ce8b555f6ee4ca = (stiffness = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).stiffness, damping = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).damping, mass = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).mass)=>damping / (2 * Math.sqrt(stiffness * mass));


function $8411513b6d8a904c$export$f05961a5126db1a3(origin, target, current) {
    return origin < target && current >= target || origin > target && current <= target;
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $6df03179fb0b95f7$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $d797c9fa536de3fa$var$sampleT = 5; // ms
function $d797c9fa536de3fa$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $d797c9fa536de3fa$var$sampleT, 0);
    return (0, $6df03179fb0b95f7$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $1d7651405cccd56f$export$b36281d89752ae66 = ({ stiffness: stiffness = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).stiffness, damping: damping = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).damping, mass: mass = (0, $cdb2fa5b2f07190d$export$ebe90cb607ad99e).mass, from: from = 0, to: to = 1, velocity: velocity = 0.0, restSpeed: restSpeed, restDistance: restDistance } = {})=>{
    velocity = velocity ? (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).s(velocity) : 0.0;
    const state = {
        done: false,
        hasReachedTarget: false,
        current: from,
        target: to
    };
    const initialDelta = to - from;
    const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
    const dampingRatio = (0, $535154748141eab4$export$7ce8b555f6ee4ca)(stiffness, damping, mass);
    const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDistance || (restDistance = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = undampedAngularFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
        // Underdamped spring (bouncy)
        resolveSpring = (t)=>to - Math.exp(-dampingRatio * undampedAngularFreq * t) * ((-velocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    } else // Critically damped spring
    resolveSpring = (t)=>{
        return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (-velocity + undampedAngularFreq * initialDelta) * t);
    };
    return (t)=>{
        state.current = resolveSpring(t);
        const currentVelocity = t === 0 ? velocity : (0, $d797c9fa536de3fa$export$854187271d233eb5)(resolveSpring, t, state.current);
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(to - state.current) <= restDistance;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
        state.hasReachedTarget = (0, $8411513b6d8a904c$export$f05961a5126db1a3)(from, to, state.current);
        return state;
    };
};



const $28396846674510da$var$timeStep = 10;
const $28396846674510da$var$maxDuration = 10000;
function $28396846674510da$export$a3670b55451fed17(generator, toUnit = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721)) {
    let overshootDuration = undefined;
    let timestamp = $28396846674510da$var$timeStep;
    let state = generator(0);
    const keyframes = [
        toUnit(state.current)
    ];
    while(!state.done && timestamp < $28396846674510da$var$maxDuration){
        state = generator(timestamp);
        keyframes.push(toUnit(state.done ? state.target : state.current));
        if (overshootDuration === undefined && state.hasReachedTarget) overshootDuration = timestamp;
        timestamp += $28396846674510da$var$timeStep;
    }
    const duration = timestamp - $28396846674510da$var$timeStep;
    /**
     * If generating an animation that didn't actually move,
     * generate a second keyframe so we have an origin and target.
     */ if (keyframes.length === 1) keyframes.push(state.current);
    return {
        keyframes: keyframes,
        duration: duration / 1000,
        overshootDuration: (overshootDuration !== null && overshootDuration !== void 0 ? overshootDuration : duration) / 1000
    };
}






function $caa8c80d15ddfe43$var$canGenerate(value) {
    return (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(value) && !isNaN(value);
}
function $caa8c80d15ddfe43$var$getAsNumber(value) {
    return (0, $2a81f6ce54bbc186$export$844ec244b1367d54)(value) ? parseFloat(value) : value;
}
function $caa8c80d15ddfe43$export$7f1511d09ee75a99(createGenerator) {
    const keyframesCache = new WeakMap();
    return (options = {})=>{
        const generatorCache = new Map();
        const getGenerator = (from = 0, to = 100, velocity = 0, isScale = false)=>{
            const key = `${from}-${to}-${velocity}-${isScale}`;
            if (!generatorCache.has(key)) generatorCache.set(key, createGenerator(Object.assign({
                from: from,
                to: to,
                velocity: velocity
            }, options)));
            return generatorCache.get(key);
        };
        const getKeyframes = (generator, toUnit)=>{
            if (!keyframesCache.has(generator)) keyframesCache.set(generator, (0, $28396846674510da$export$a3670b55451fed17)(generator, toUnit));
            return keyframesCache.get(generator);
        };
        return {
            createAnimation: (keyframes, shouldGenerate = true, getOrigin, name, motionValue)=>{
                let settings;
                let origin;
                let target;
                let velocity = 0;
                let toUnit = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721);
                const numKeyframes = keyframes.length;
                /**
                 * If we should generate an animation for this value, run some preperation
                 * like resolving target/origin, finding a unit (if any) and determine if
                 * it is actually possible to generate.
                 */ if (shouldGenerate) {
                    toUnit = (0, $ad3259e3871471aa$export$4bcf070800a2fd35)(keyframes, name ? (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get((0, $c198c52b86dad803$export$b6557f397a74f857)(name)) : undefined);
                    const targetDefinition = keyframes[numKeyframes - 1];
                    target = $caa8c80d15ddfe43$var$getAsNumber(targetDefinition);
                    if (numKeyframes > 1 && keyframes[0] !== null) /**
                         * If we have multiple keyframes, take the initial keyframe as the origin.
                         */ origin = $caa8c80d15ddfe43$var$getAsNumber(keyframes[0]);
                    else {
                        const prevGenerator = motionValue === null || motionValue === void 0 ? void 0 : motionValue.generator;
                        /**
                         * If we have an existing generator for this value we can use it to resolve
                         * the animation's current value and velocity.
                         */ if (prevGenerator) {
                            /**
                             * If we have a generator for this value we can use it to resolve
                             * the animations's current value and velocity.
                             */ const { animation: animation, generatorStartTime: generatorStartTime } = motionValue;
                            const startTime = (animation === null || animation === void 0 ? void 0 : animation.startTime) || generatorStartTime || 0;
                            const currentTime = (animation === null || animation === void 0 ? void 0 : animation.currentTime) || performance.now() - startTime;
                            const prevGeneratorCurrent = prevGenerator(currentTime).current;
                            origin = prevGeneratorCurrent;
                            velocity = (0, $d797c9fa536de3fa$export$854187271d233eb5)((t)=>prevGenerator(t).current, currentTime, prevGeneratorCurrent);
                        } else if (getOrigin) /**
                             * As a last resort, read the origin from the DOM.
                             */ origin = $caa8c80d15ddfe43$var$getAsNumber(getOrigin());
                    }
                }
                /**
                 * If we've determined it is possible to generate an animation, do so.
                 */ if ($caa8c80d15ddfe43$var$canGenerate(origin) && $caa8c80d15ddfe43$var$canGenerate(target)) {
                    const generator = getGenerator(origin, target, velocity, name === null || name === void 0 ? void 0 : name.includes("scale"));
                    settings = Object.assign(Object.assign({}, getKeyframes(generator, toUnit)), {
                        easing: "linear"
                    });
                    // TODO Add test for this
                    if (motionValue) {
                        motionValue.generator = generator;
                        motionValue.generatorStartTime = performance.now();
                    }
                }
                /**
                 * If by now we haven't generated a set of keyframes, create a generic generator
                 * based on the provided props that animates from 0-100 to fetch a rough
                 * "overshootDuration" - the moment when the generator first hits the animation target.
                 * Then return animation settings that will run a normal animation for that duration.
                 */ if (!settings) {
                    const keyframesMetadata = getKeyframes(getGenerator(0, 100));
                    settings = {
                        easing: "ease",
                        duration: keyframesMetadata.overshootDuration
                    };
                }
                return settings;
            }
        };
    };
}


const $f127ff01d76ed49f$export$b36281d89752ae66 = (0, $caa8c80d15ddfe43$export$7f1511d09ee75a99)((0, $1d7651405cccd56f$export$b36281d89752ae66));


const $6ecce71d40421a51$var$box = document.getElementById("box");
const $6ecce71d40421a51$var$overlay = document.getElementById("overlay");
const $6ecce71d40421a51$var$modal = document.getElementById("modal");
const $6ecce71d40421a51$var$openModalButton = document.getElementById("open-modal-button");
const $6ecce71d40421a51$var$closeModalButton = document.getElementById("close-modal-button");
$6ecce71d40421a51$var$openModalButton.addEventListener("click", ()=>{
    $6ecce71d40421a51$var$overlay.style.visibility = "visible";
    document.body.classList.add("no-scroll");
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)($6ecce71d40421a51$var$overlay, {
        opacity: 1,
        backdropFilter: "blur(10px)"
    }, {
        easing: (0, $f127ff01d76ed49f$export$b36281d89752ae66)({
            stiffness: 50,
            damping: 8,
            mass: 0.8
        })
    });
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)($6ecce71d40421a51$var$modal, {
        translateY: -100,
        opacity: 1
    }, {
        easing: (0, $f127ff01d76ed49f$export$b36281d89752ae66)({
            stiffness: 65,
            damping: 12,
            mass: 1
        })
    });
});
// Function to handle the animation
function $6ecce71d40421a51$var$closeAnimation() {
    const animation = (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)($6ecce71d40421a51$var$overlay, {
        opacity: 0,
        backdropFilter: "blur(0px)"
    }, {
        easing: (0, $f127ff01d76ed49f$export$b36281d89752ae66)({
            stiffness: 65,
            damping: 12,
            mass: 1
        })
    });
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)($6ecce71d40421a51$var$modal, {
        translateY: 0,
        opacity: 0
    }, {
        easing: (0, $f127ff01d76ed49f$export$b36281d89752ae66)({
            stiffness: 50,
            damping: 8,
            mass: 0.8
        })
    });
    // Wait for the animation to complete
    animation.finished.then(()=>{
        $6ecce71d40421a51$var$overlay.style.visibility = "hidden";
        document.body.classList.remove("no-scroll");
    });
}
// Attach the event listener to your button
$6ecce71d40421a51$var$closeModalButton.addEventListener("click", $6ecce71d40421a51$var$closeAnimation);
function $6ecce71d40421a51$var$handleEscapeKey(event) {
    if (event.key === "Escape" || event.keyCode === 27) $6ecce71d40421a51$var$closeAnimation();
}
// Event listener for the Escape key
document.addEventListener("keydown", $6ecce71d40421a51$var$handleEscapeKey);


//# sourceMappingURL=index.a75b7905.js.map
